import React from 'react'
import { useI18n } from '../../i18n'

function InlineSettingInput({ value, onChange, type = 'number', min, max, className }) {
  const handleChange = (e) => {
    const v = e.target.value
    if (type === 'number') {
      const parsed = v === '' ? '' : String(Math.max(min ?? 0, Number(v) || (min ?? 0)))
      onChange(parsed === '' ? String(min ?? 0) : parsed)
    } else {
      onChange(v)
    }
  }
  return (
    <input
      type={type}
      className={`media-selector-desc-inline-input ${className || ''}`}
      value={value}
      onChange={handleChange}
      min={min}
      max={max}
      size={3}
    />
  )
}

/** Структурированное описание Media Selector с блоками и цветами. */
export default function MediaSelectorDescription({ settings = {}, onChange }) {
  const { t } = useI18n()
  return (
    <div className="media-selector-desc">
      <p className="media-selector-desc-intro">{t('settings.mediaSelector.intro')}</p>

      <section className="media-selector-desc-block media-selector-desc-block--sales">
        <h3 className="media-selector-desc-title">{t('settings.mediaSelector.salesTitle')}</h3>
        <h4 className="media-selector-desc-subtitle">{t('settings.mediaSelector.salesSessionTitle')}</h4>
        <ol className="media-selector-desc-list">
          <li>{t('settings.mediaSelector.salesSession1')}</li>
          <li>
            {t('settings.mediaSelector.salesSession2Before')}
            <InlineSettingInput
              value={String(settings.bot_session_switch_min_hours ?? '')}
              onChange={(v) => onChange('bot_session_switch_min_hours', v)}
              min={0}
            />
            {t('settings.mediaSelector.salesSession2After')}
          </li>
          <li>{t('settings.mediaSelector.salesSession3')}</li>
        </ol>
        <h4 className="media-selector-desc-subtitle">{t('settings.mediaSelector.salesGroupTitle')}</h4>
        <ul className="media-selector-desc-list media-selector-desc-list--bullets">
          <li>{t('settings.mediaSelector.salesGroup1')}</li>
          <li>{t('settings.mediaSelector.salesGroup2')}</li>
          <li>{t('settings.mediaSelector.salesGroup3')}</li>
        </ul>
      </section>

      <section className="media-selector-desc-block media-selector-desc-block--chat">
        <h3 className="media-selector-desc-title">{t('settings.mediaSelector.chatTitle')}</h3>
        <ol className="media-selector-desc-list">
          <li>{t('settings.mediaSelector.chat1')}</li>
          <li>
            {t('settings.mediaSelector.chat2Before')}
            <InlineSettingInput
              value={String(settings.bot_chat_media_recent_days ?? '')}
              onChange={(v) => onChange('bot_chat_media_recent_days', v)}
              min={1}
            />
            {t('settings.mediaSelector.chat2After')}
          </li>
          <li>{t('settings.mediaSelector.chat3')}</li>
          <li>{t('settings.mediaSelector.chat4')}</li>
          <li>{t('settings.mediaSelector.chat5')}</li>
        </ol>
      </section>

      <section className="media-selector-desc-block media-selector-desc-block--transition">
        <h3 className="media-selector-desc-title">{t('settings.mediaSelector.transitionTitle')}</h3>
        <p className="media-selector-desc-text">{t('settings.mediaSelector.transitionText')}</p>
      </section>
    </div>
  )
}
